import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import Icon from '@mui/material/Icon';
import { Box, Typography, ThemeProvider } from '@mui/material';
import React, { useState } from 'react';
import { buttonsTheme, primaryColor, secondaryColor } from '../shared/_theme.jsx';

export default class ResponsibilityList extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @returns {function(object): React.ReactElement}
     */
    static getReactComponent($) {
        return () => {
            // TODO Get the height of the component from draw & Handle the scroller

            // listen to properties
            const data = useProperty($, 'responsibilities');
            const [selected, setSelected] = useState();
            const canEdit = useProperty($, 'can edit');

            const handleSelection = (resp) => {
                setSelected(resp);
                $.set('Selected Resp', resp);
                $.trigger('On Item Clicked');
            };
            const handleDeletion = (resp) => {
                setSelected(resp);
                $.set('Selected Resp', resp);
                $.trigger('On Delete');
            };
            const items = [];

            data?.forEach((resp, index) => {
                items.push(
                    <Box>
                        <Box
                            sx={{
                                position: 'relative',
                                boxSizing: 'border-box',
                                padding: '10px',
                                backgroundColor: selected === resp ? primaryColor : 'white',
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: selected === resp ? primaryColor : '#0000001E' },
                                '&:hover .delete': { display: 'block' },
                            }}
                            onClick={() => handleSelection(resp)}
                        >
                            <Box style={{ padding: '10px' }}>
                                <Typography
                                    style={{
                                        display: 'inline-block',
                                        width: '150px',
                                        color: selected === resp ? 'white' : 'black',
                                    }}
                                >
                                    <b>{resp.RespNo}</b>
                                </Typography>
                                <Typography
                                    style={{
                                        display: 'inline-block',
                                        color: selected === resp ? 'white' : secondaryColor,
                                    }}
                                >
                                    {resp.RespShort}
                                </Typography>
                            </Box>
                            <Box>
                                <Icon
                                    style={{
                                        paddingRight: '20px',
                                        color: selected !== resp ? primaryColor : 'white',
                                        position: 'relative',
                                        top: '6px',
                                    }}
                                >
                                    {resp.StatusText === 'Responsibility complete'
                                        ? 'circle'
                                        : 'radio_button_unchecked'}
                                </Icon>
                                <Typography
                                    style={{
                                        display: 'inline-block',
                                        color: selected === resp ? 'white' : secondaryColor,
                                    }}
                                >
                                    {resp.StatusText}
                                </Typography>
                            </Box>
                            {canEdit && (
                                <Icon
                                    className="delete"
                                    sx={{
                                        display: 'none',
                                        color: selected !== resp ? primaryColor : 'white',
                                        height: '100%',
                                        position: 'absolute',
                                        right: '10px',
                                        top: '30px',
                                        fontSize: '30px',
                                        '&:hover': { color: '#8c5400' },
                                    }}
                                    onClick={(e) => handleDeletion(resp)}
                                >
                                    delete_forever
                                </Icon>
                            )}
                        </Box>
                        <hr style={{ border: 'solid 1px #0000001E', padding: 0, margin: 0 }} />
                    </Box>
                );
            });

            return (
                <React.Fragment>
                    <ThemeProvider theme={buttonsTheme}>
                        <Box className="resp-list" sx={{ width: 1, height: 1, overflow: 'auto' }}>
                            {items}
                        </Box>
                    </ThemeProvider>
                </React.Fragment>
            );
        };
    }
}

registerBrick('018b1f329cec1ac5e1ac', ResponsibilityList);
